import * as yup from 'yup';
import { isValidPhoneNumber } from '../../utils/phoneUtils';

export const nameRule = yup.string().required("A név megadása kötelező!");

// The number is how the shop reaches a guest about their booking, and the only one it has.
// The rule it replaces was digits and nothing else: it turned away "+36 30 123 4567" — the way
// the number is written everywhere else on this site — and passed a single digit.
export const phoneNumberRule = yup
  .string()
  .required("A telefonszám megadása kötelező!")
  // Empty is `required`'s to report, not this one's.
  .test(
    "phoneNumber",
    "A telefonszám helytelen! Például: +36 30 123 4567",
    (value) => !value || isValidPhoneNumber(value)
  );

export const emailRule = yup
  .string()
  .trim()
  .required("Az email cím megadása kötelező!")
  .email("Az email cím helytelen!");

// At sign-in: whatever the account's password is, it only has to be there.
export const passwordRule = yup.string().required("A jelszó megadása kötelező!");

// The backend's rule (PasswordService): at least 8 characters, at most 72 bytes of UTF-8.
export const newPasswordRule = yup
  .string()
  .required("A jelszó megadása kötelező!")
  .test("minLength", "A jelszó legalább 8 karakter legyen!", (value) => !value || [...value].length >= 8)
  .test("maxBytes", "A jelszó túl hosszú!", (value) => !value || new TextEncoder().encode(value).length <= 72);

export const codeRule = yup
  .string()
  .trim()
  .required("A kód megadása kötelező!")
  .matches(/^\d{6}$/, "A kód 6 számjegyből áll!");
